// extracted by mini-css-extract-plugin
export var container = "_s1-0";
export var table = "_s1-2";
export var tableWrapper = "_s1-1";